





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { Channel } from '../interfaces';
import ChannelCard from '@/components/ChannelCard.vue';

@Component({
  components: {
    ChannelCard,
  },
})
export default class Tag extends Vue {
  @State('channels') private stateChannels!: Channel[];
  @Mutation('setSubject') private mutationSetSubject: any;

  public async mounted() {
    this.mutationSetSubject('');
  }

  get channelsForTag(): Channel[] {
    const channelsWithFormattedTags = this.stateChannels.filter((channel) => {
      if (channel.tags && channel.tags.toLowerCase().includes(this.routeName.toLowerCase())) {
        return channel;
      }
    });
    return channelsWithFormattedTags;
  }

  get tags(): string[] {
    const channels = this.stateChannels ? this.stateChannels : [];
    const tags = channels.map((channel) => {
      if (channel.tags) {
        return this.tagsFormatted(channel.tags);
      } else {
        return [];
      }
    });
    // use a Set to get unique value
    return [...new Set(this.flatten(tags))];
  }

  // method used to flatten an array of arrays
  private flatten(arr: any, result: string[] = []) {
    for (let i = 0, length = arr.length; i < length; i++) {
      const value: string = arr[i];
      if (Array.isArray(value)) {
        this.flatten(value, result);
      } else {
        result.push(value);
      }
    }
    return result;
  }

  private tagsFormatted(tags: string) {
    const separators: string[] = [' - ', ' – ', ', '];
    let tagsFormatted: string[] = tags.split(new RegExp(separators.join('|'), 'g'));
    tagsFormatted = tagsFormatted.map((tag) => {
      return tag.charAt(0).toUpperCase() + tag.slice(1);
    });
    return tagsFormatted;
  }

  get routeName(): string {
    if (this.$route.params.tag) {
      return this.$route.params.tag.replace(/\+/g, ' ');
    } else {
      return '';
    }
  }

}
